import { useSearchParams } from "react-router-dom"
import { BadRequestPage, NotFoundPage, ServerErrorPage, ServiceUnavailablePage } from "popopo-lib-react/simple-pages"
import "../style/simple-pages.scss"

/**
 * Debug page for testing error pages.
 * Usage: /debug/error?code=400 or /debug/error?code=404 or /debug/error?code=500 or /debug/error?code=503
 */
export const DebugError = () => {
  const [searchParams] = useSearchParams()
  const code = searchParams.get("code") || "404"

  switch (code) {
    case "400":
      return <BadRequestPage locale="ja" homeUrl="/" />
    case "500":
      return <ServerErrorPage locale="ja" homeUrl="/" />
    case "503":
      return <ServiceUnavailablePage locale="ja" homeUrl="/" />
    case "404":
    default:
      return <NotFoundPage locale="ja" homeUrl="/" />
  }
}
